/**
 * Enum for available date field options for QBO invoice default dates
 * Maps to date fields available in the Orders table
 */
enum QBOInvoiceDateFieldEnum {
    DELIVERY_DATE = "delivery_date",
    SHIP_DATE = "ship_date",
    DUE_DATE = "due_date",
    DO_NOT_SHIP_BEFORE_DATE = "do_not_ship_before_date",
    SUBMIT_DATE = "submit_date",
    CONFIRMED_DATE = "confirmed_date",
}

export default QBOInvoiceDateFieldEnum;
